import { GetContextMenuItemsParams } from '@ag-grid-community/core'
import { filterOnCell } from '@helios/utils'

/**
 * Get selected rows from a table for the context menu.
 */
export function getSelectedForContextMenu<T>(
  params: GetContextMenuItemsParams,
): T[] {
  const apiSelection = params.api.getSelectedNodes()
  const areMultipleSelected = apiSelection.length > 1
  if (areMultipleSelected) {
    return apiSelection
      .filter(x => !x.group && x.data !== undefined)
      .map(x => x.data) as T[]
  }

  const data = params.node?.data
  if (!data) {
    return [] as T[]
  }

  return [data] as T[]
}

/**
 * Returns the context menu items for the "Filter On Cell" action.
 */
export function getFilterOnCellContextMenu(params: GetContextMenuItemsParams) {
  const isFilterAllowed = params.column?.isFilterAllowed()
  const selectedRow = params.api.getSelectedNodes() ?? []
  return [
    {
      name: 'Filter On Cell',
      action: () => {
        filterOnCell(params)
      },
      disabled: selectedRow.length > 1 ? true : isFilterAllowed ? false : true,
      tooltip:
        selectedRow.length > 1
          ? 'Multiple cells selected. Please select only one cell.'
          : !isFilterAllowed
          ? 'Filter Not Allowed On This Column.'
          : undefined,
    },
  ]
}
